<template>
    <transition name="slide-fade" mode="out-in">
        <table class="table round_table" id="league_result_table">
            <tr>
                <th></th>
                <th class="text-left">Team</th>
                <th class="text-left">Played</th>
                <th class="text-left">Won</th>
                <th class="text-left">Drawn</th>
                <th class="text-left">Lost</th>
                <th class="text-left">Shots For</th>
                <th class="text-left">Shots Against</th>
                <th class="text-left">Points</th>
                <th class="text-left">Diff</th>
            </tr>
            <tr v-for="item in table">
                <td> {{item.position}} </td>
                <td class="text-left"> {{item.name}} </td>
                <td class="text-left"> {{item.played}} </td>
                <td class="text-left"> {{item.won}} </td>
                <td class="text-left"> {{item.drawn}} </td>
                <td class="text-left"> {{item.lost}} </td>
                <td class="text-left"> {{item.shots_f}} </td>
                <td class="text-left"> {{item.shots_a}} </td>
                <td class="text-left"> {{item.points}} </td>
                <td class="text-left"> {{item.diff}} </td>
            </tr>
        </table>
    </transition>
</template>
<script>
    export default{
        props:['table']
    }
</script>


// WEBPACK FOOTER //
// src/components/Leagues/Table.vue